import * as React from 'react';

import {
  ListItemTextStyled,
  ListItemOnClickCaptureStyled,
  ListItemButtonStyled,
} from './MenuItemSingle.style';

import { LinkStyled } from '../mobile-menu/MobileMenu.style';
import { Link } from '../../../models/auto-generated-strapi-types/types/components/Link';
import { MenuItemStyle } from '../../../models/domain/enum';

const MenuItemSingle = ({
  link,
  onClick,
  level,
  open,
  styleItem = MenuItemStyle.PRIMARY,
}: {
  link: Link;
  onClick: (...arg: any[]) => any;
  level: number;
  open?: boolean;
  styleItem?: MenuItemStyle;
}) => {
  return (
    <>
      <ListItemButtonStyled level={level} openLocal={open}>
        <LinkStyled href={link.url || ''} passHref>
          <ListItemOnClickCaptureStyled onClick={onClick} styleItem={styleItem}>
            <ListItemTextStyled
              primary={link.text || ''}
              styleItem={styleItem}
            />
          </ListItemOnClickCaptureStyled>
        </LinkStyled>
      </ListItemButtonStyled>
    </>
  );
};

export default MenuItemSingle;
